import 'owl.carousel';

$(document).ready(() => {

    // Home - Carousel Hero
    var hero = $('.hero-carousel.owl-carousel').owlCarousel({
        loop:true,
        items:1,
        mouseDrag: false,
        touchDrag: false,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 5800,
        onChange: (e) => {
            setTimeout(() => {
                $(e.currentTarget).find('video').each((i,e) => {
                    e.pause();
                    e.currentTime = 0;
                });
            },0);

            setTimeout(() => {
                $(e.currentTarget).find('.owl-item.active video').each((i,e) => {
                    e.play();
                });
            },0);

        },
        onInitialized: (e) => {
            setTimeout(() => {
                var stage = $(e.target).find('.owl-stage');
                stage.addClass('ease-transition');
            },3500);
        }
    });

    // Home - Carousel #1
    $('.services-block-carousel.owl-carousel').owlCarousel({
        loop:true,
        items:1,
        mouseDrag: true,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000
    });

    // Home - Carousel #2
    $('.story-block-carousel.owl-carousel').owlCarousel({
        loop:true,
        items:1,
        mouseDrag: true,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000
    });

});



// WEBPACK FOOTER //
// ./src/js/carousel.js